import CreateEditPage from "./CreateEditPage";

export default CreateEditPage;